export default "__VITE_ASSET__DTE2zs2W__"